import { defineComponent as _defineComponent } from 'vue'
import isString from 'lodash/isString';
import { computed, onMounted, onBeforeUnmount, watch, ref } from 'vue';
import { useRoute } from 'vue-router/composables';

import { WorkflowId, WorkflowNodeId, WorkflowVersionId } from '@ply-io/ply-front-shared-utilities';

// import Footer from './Footer.vue';
import RightSidePanel from './RightSidePanel.vue';
import CreateSubflowFooter from '../helpers/CreateSubflowFooter.vue';
import MoveStepFooter from '../helpers/MoveStepFooter.vue';
import FlowTree from '@/components/FlowTree/FlowTree.vue';
import {
	useWorkflowsGetters,
	useSelectedNodeActions,
	useWidgetEditorGetters,
	useNodesGetters,
	// useWidgetEditorActions,
	useLeftSideDrawerGetters,
} from '@/store-composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'InterfaceFocusedFlow',
  props: {
    workflowId: null,
    hasLoadedNodesData: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { workflowId: WorkflowId; hasLoadedNodesData: boolean }

const route = useRoute();
const nodeId = computed<WorkflowNodeId | string | undefined>(() => {
	if (!route.params.nodeID) {
		return undefined;
	}
	const parsedNodeId = parseInt(route.params.nodeID);
	if (Number.isNaN(parsedNodeId)) {
		return route.params.nodeID;
	} else {
		return parsedNodeId;
	}
});

const { getWorkflow } = useWorkflowsGetters();
const workflow = computed(() => {
	const wf = getWorkflow.value(props.workflowId);
	if (!wf) {
		throw new Error('Workflow not found');
	}
	return wf;
});
const { closeSideBar, setEditNodeID } = useSelectedNodeActions();
const { widgetNodeId, widgetId, widgetWorkflowVersionId } = useWidgetEditorGetters();
const widgetEntitiesIds = computed(() => ({
	widgetId: widgetId.value,
	widgetWorkflowVersionId: widgetWorkflowVersionId.value,
	widgetNodeId: widgetNodeId.value,
}));
const lastWidgetNodeId = ref<{ widgetId: string; widgetWorkflowVersionId: WorkflowVersionId; widgetNodeId: WorkflowNodeId } | null>(null);
const { isLeftSideDrawerOpen } = useLeftSideDrawerGetters();
const noActiveWindow = computed(() => route.name === 'Feature' && !isLeftSideDrawerOpen.value);
const needToApplyLastWidget = computed(() => noActiveWindow.value);
watch(needToApplyLastWidget, (newV) => {
	if (newV) {
		applyLastWidget();
	}
});
const applyLastWidget = () => {
	if (lastWidgetNodeId.value) {
		setEditNodeID(lastWidgetNodeId.value.widgetNodeId);
	}
};
watch(widgetEntitiesIds, (newV) => {
	if (!!newV.widgetId && !!newV.widgetWorkflowVersionId) {
		if (newV.widgetNodeId) {
			lastWidgetNodeId.value = {
				widgetId: newV.widgetId,
				widgetWorkflowVersionId: newV.widgetWorkflowVersionId,
				widgetNodeId: newV.widgetNodeId,
			};
		}
	}
});
const { isWidget, isEndRunWidget } = useNodesGetters();
const isWidgetNode = (nodeId: WorkflowNodeId | string | undefined) =>
	!!nodeId && !isString(nodeId) && (isWidget.value(nodeId) || isEndRunWidget.value(nodeId));
onMounted(() => {
	setTimeout(() => {
		if (!widgetNodeId.value && (!nodeId.value || !isWidgetNode(nodeId.value))) {
			// TODO: select first widget available
			console.warn('No widget chosen, need to choose!');
		}
	}, 1000);
});
onBeforeUnmount(() => {
	// TODO - reset widget editor state
	console.warn('TODO: need to reset widget editor state');
});

return { __sfc: true,route, nodeId, props, getWorkflow, workflow, closeSideBar, setEditNodeID, widgetNodeId, widgetId, widgetWorkflowVersionId, widgetEntitiesIds, lastWidgetNodeId, isLeftSideDrawerOpen, noActiveWindow, needToApplyLastWidget, applyLastWidget, isWidget, isEndRunWidget, isWidgetNode, RightSidePanel, CreateSubflowFooter, MoveStepFooter, FlowTree }
}

})